/**
 * Irmão: `src/app/components/filters/tokens.ts`.
 *
 * Duplicação deliberada (openspec/changes/flashcards-revisao-redesign/design.md,
 * Decisão 2). Estes mapas não são importados de `components/filters/`: uma
 * correção de foco ou de telha num lado tem de ser conferida no outro. Não
 * extrair uma base genérica enquanto só existirem estes dois consumidores.
 *
 * As classes são literais completos de propósito: o Tailwind varre o texto
 * fonte, e uma classe montada em runtime (`bg-accent-${accent}`) não entra
 * na folha de estilo.
 */

/** Identidade da seção. Vive na telha do ícone — nunca numa ficha selecionada. */
export type RevisaoSectionAccent = "blue" | "purple" | "green" | "orange" | "cyan";

export const REVISAO_ACCENT_TILE: Record<RevisaoSectionAccent, string> = {
  blue: "bg-accent-blue/[0.14] text-accent-blue-ink",
  purple: "bg-accent-purple/[0.14] text-accent-purple-ink",
  green: "bg-accent-green/[0.14] text-accent-green-ink",
  orange: "bg-accent-orange/[0.14] text-accent-orange-ink",
  cyan: "bg-accent-cyan/[0.14] text-accent-cyan-ink",
};

/** Anel de foco compartilhado por trilho, seção e ficha. */
export const REVISAO_FILTER_FOCUS_RING =
  "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-select/60 focus-visible:ring-offset-2 focus-visible:ring-offset-surface";

export function revisaoFilterCx(...values: Array<string | false | null | undefined>): string {
  return values.filter(Boolean).join(" ");
}

/**
 * How many options a section shows before an overflow control appears.
 * Same ladder as the sibling `overflowMode`: ≤12 none, 13–24 inline, above that a dialog.
 * One affordance at a time — never "+N mais" beside "Ver todas".
 */
export const REVISAO_VISIBLE_OPTIONS = 12;

export type RevisaoOverflowMode = "none" | "inline" | "modal";

export function revisaoOverflowMode(total: number): RevisaoOverflowMode {
  if (total <= REVISAO_VISIBLE_OPTIONS) return "none";
  if (total <= REVISAO_VISIBLE_OPTIONS * 2) return "inline";
  return "modal";
}
